import { useSyncExternalStore } from 'react';
import type { SessionEngine, Snapshot } from './engine';

export const useEngine = (engine: SessionEngine): Snapshot => useSyncExternalStore(engine.subscribe, engine.getSnapshot);
